import type { Env as StaticFilesEnv } from './types';

export type Environment = 'development' | 'qa' | 'staging' | 'oldstaging' | 'production';

export const getStaticFilesEnv = (env: Environment): StaticFilesEnv => {
  if (['oldstaging', 'staging'].includes(env)) {
    return 'production';
  }

  return env as StaticFilesEnv;
};
